import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-input-select-laudo',
  templateUrl: './input-select-laudo.component.html',
  styleUrls: ['./input-select-laudo.component.scss']
})
export class InputSelectLaudoComponent implements OnInit {
  id = new Date().getTime();
  @Input() control = new FormControl();
  @Input() label = "Desc. Input";
  @Input() required:boolean;
  @Input() options = [
    {label: 'Selecione', value: ''},
  ];
 // @Input() value: any;

  constructor() {}

  ngOnInit() {
   
  }
}
